import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Gem, Cog } from 'lucide-react';
interface SlideCompletePropositionProps {
  onContinue: () => void;
}
const TRACKS = [{
  kicker: 'Strategic brands',
  title: 'Make the content work harder',
  desc: "Build and activate a reusable Treasure Chest that turns LEO's master content into short, interactive and measurable campaign experiences.",
  icon: Gem
}, {
  kicker: 'Mature & legacy brands',
  title: 'Keep the campaign engine running',
  desc: 'Snakker takes responsibility for the full cycle, protecting current revenue without taking time away from strategic priorities.',
  icon: Cog
}];
export function SlideCompleteProposition({
  onContinue
}: SlideCompletePropositionProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const timers = [300, 900, 1600].map((ms, idx) => setTimeout(() => setStage(idx + 1), ms));
    return () => timers.forEach(clearTimeout);
  }, []);
  return <div className="h-full w-full flex flex-col px-8 py-10 md:px-20 md:py-12 max-w-7xl mx-auto" data-id="element-427" data-mp="1a5emwevac1zx">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="space-y-3 shrink-0" data-id="element-428" data-mp="1f4hgn35telsl">
        <p className="text-teal-400 font-semibold tracking-widest uppercase text-sm" data-id="element-429" data-mp="1ou0xy4dvq7lc">
          The Complete Proposition
        </p>
        <h2 className="text-3xl md:text-5xl font-serif text-white" data-id="element-430" data-mp="r9oi6jvywric">
          From content to market impact
        </h2>
      </motion.div>

      <div className="flex-1 min-h-0 flex flex-col justify-center max-w-5xl mx-auto w-full mt-6 space-y-4" data-id="element-431" data-mp="11589eszl720r">
        {TRACKS.map((track, idx) => {
        const Icon = track.icon;
        const visible = stage >= idx + 1;
        return <motion.div key={track.title} initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: visible ? 1 : 0,
          y: visible ? 0 : 16
        }} className="bg-navy-900/50 border border-navy-700 rounded-2xl p-6 flex items-start gap-5" data-id="element-432" data-mp="2ckn6rxvpjvwe" data-mpi={idx}>
              <div className="w-12 h-12 rounded-xl bg-teal-400/10 text-teal-400 flex items-center justify-center shrink-0" data-id="element-433" data-mp="qhwro1ckp87t">
                <Icon className="w-6 h-6" data-id="element-434" data-mp="meqqv988c98q" />
              </div>
              <div data-id="element-435" data-mp="3uxg273j43ta0">
                <p className="text-teal-400 text-[11px] font-semibold uppercase tracking-widest mb-1.5" data-id="element-436" data-mp="3uwwibh9wiutc">
                  {track.kicker}
                </p>
                <h3 className="text-white font-semibold text-xl mb-2" data-id="element-437" data-mp="7ju7q0yvu1gv">
                  {track.title}
                </h3>
                <p className="text-white/65 leading-relaxed" data-id="element-438" data-mp="2s2ibtrgq1sb">{track.desc}</p>
              </div>
            </motion.div>;
      })}

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: stage >= 3 ? 1 : 0,
        y: stage >= 3 ? 0 : 12
      }} className="bg-teal-400/[0.07] border border-teal-400/40 rounded-2xl px-7 py-6 text-center !mt-6" data-id="element-439" data-mp="3772877gyvkcs">
          <p className="text-white/40 text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-440" data-mp="2n5hf53rmdi4b">
            Across both
          </p>
          <p className="text-white font-serif text-xl md:text-2xl leading-snug" data-id="element-441" data-mp="2s4ka1vdvy7yk">
            Snakker is the activation and execution partner that turns approved
            content into{' '}
            <span className="text-teal-400" data-id="element-442" data-mp="3krevovmfvddm">measurable market impact</span>.
          </p>
        </motion.div>
      </div>
    </div>;
}